import  * as api from  '@/api/kzActivity/discuss'
import * as TYPES from './type';

export default {
  // 课中活动讨论
  async getTalkList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTalkList(paramets)
    commit(TYPES.Talk_LIST, { result })
    cb && cb()
  },
  async getTalkReplyList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTalkReplyList(paramets)
    commit(TYPES.Talk_INFO, { result, type: 'replyList' })
    cb && cb()
  },
  setTalkReplyList({ commit, state }, { list, cb }) {
    commit(TYPES.Talk_INFO, { list, type: 'replyList' })
    cb && cb()
  },
  async postAddTalkPraise({ commit, state }, { paramets, cb }) {
    const result = await api.reqAddTalkPraise(paramets)
    commit(TYPES.Talk_INFO, { result, type: 'addPraise' })
    cb && cb()
  },
  async delDelTalk({ commit, state }, { paramets, cb }) {
    const result = await api.reqDelTalk(paramets)
    commit(TYPES.Talk_INFO, { result, type: 'delTalk' })
    cb && cb()
  },
  async deleteReplyTalk({ commit, state }, { paramets, cb }) {
    const result = await api.reqDelReplyTalk(paramets)
    commit(TYPES.Talk_INFO, { result, type: 'delReply' })
    cb && cb()
  },
  async postAddReplyTalk({ commit, state }, { paramets, cb }) {
    const result = await api.reqAddReplyTalk(paramets)
    commit(TYPES.Talk_INFO, { result, type: 'addReply' })
    cb && cb()
  },
}